/* El icono de cada meta («Recibir reservas», «Vender productos»…): el mismo en
   la bienvenida, en el panel de negocio y objetivos y en las franjas de debajo
   del título. */
import { IconArticle, IconBuildingStore, IconCalendarEvent, IconReceipt, IconShoppingCart } from '@tabler/icons-react'
import type { WelcomeGoal } from '../lib/welcomeAnswers'

export const GOAL_ICONS: Record<WelcomeGoal, typeof IconArticle> = {
  bookings: IconCalendarEvent,
  services: IconReceipt,
  products: IconShoppingCart,
  blog: IconArticle,
  showcase: IconBuildingStore,
}
